import { get } from "lodash-es";

export function deepFirstTraversal<T = Record<string, any>>(
  tree: Array<T>,
  // eslint-disable-next-line no-unused-vars
  callback: (el: T, parent?: T) => boolean | void,
  childrenKey = 'children',
  parent?: T
) {
  for (let i = 0; i < tree?.length ?? 0; i++) {
    // 获取当前树的节点
    const treeItem = tree[i]
    // 调用处理函数，并传参参数，获取shouldContinue标志位
    const shouldContinue = callback(treeItem, parent) ?? true
    // 判断是否需要递归该节点的子节点
    if (
      // 处理函数返回真值，即需要递归其子节点
      shouldContinue &&
      // 当前节点为对象类型
      treeItem instanceof Object &&
      // 当前节点拥有子节点，且其key值为childrenKey
      childrenKey in treeItem &&
      // 当前节点的childrenKey值对应的属性值为数组类型
      (treeItem as any)[childrenKey] instanceof Array
    ) {
      // 递归调用深度遍历函数
      deepFirstTraversal(
        (treeItem as any)[childrenKey],
        callback,
        childrenKey,
        treeItem
      )
    }
  }
}

export function findTreePath<T = Record<string, any>>(
  data: T[],
  value: any,
  options: {
    valueKey: string,
    childrenKey?: string,
  }
) {
  const { valueKey, childrenKey = "children" } = options;
  const paths: T[] = [];
  const dfs = (arr: T[]) => {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i] as Record<string, any>;
      if (!item) {
        continue;
      }
      if ((item as any)[valueKey] === value) {
        paths.unshift(arr[i]);
        return true
      } else if (item[childrenKey]) {
        if (dfs(item[childrenKey])) {
          paths.unshift(arr[i])
          return true
        }
      }
    }
    return false
  }
  dfs(data)

  return paths;
}

export function listToTree<T = Record<string, any>>(
  data: Array<Record<string, any>>,
  options: {
    valueKey: string,
    parentKey: string,
  },
  parentId: any,
) {
  const { valueKey, parentKey } = options;
  const tree: Array<T & {
    children: T[];
  }> = [];

  for (let i = 0; i < data.length; i++) {
    if (get(data[i], parentKey) === parentId) {
      const node = {
        ...data[i],
        children: listToTree(data, options, data[i][valueKey]),
      } as any;
      tree.push(node);
    }
  }

  return tree;
}